import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const FaqPage = lazy(() =>
  import("@/admin/pages/FaqPage").then((m) => ({ default: m.FaqPage })),
);

export const Route = createFileRoute("/admin/faq")({
  component: () => (
    <Suspense fallback={null}>
      <FaqPage />
    </Suspense>
  ),
});
